import React from 'react';
import styled from 'styled-components';
import { device } from '../../constants';
import { MotionCtaCircle } from '../Motion';

interface CtaPhotoProps {
  src: string;
}

const CtaPhoto = ({ src }: CtaPhotoProps) => {
  return (
    <PhotoWrapper>
      <CtaImage draggable={false} src={src} />
      <Circle1 size={166} />
      <Circle2 size={328} />
      <Circle3 size={510} />
    </PhotoWrapper>
  );
};
const PhotoWrapper = styled.div`
  position: relative;
  width: auto;
  min-width: 509px;
  padding: 0 10px;
  display: flex;
  align-items: flex-end;

  @media screen and (${device.md}) {
    min-width: 250px;
    align-self: flex-end;
  }
  @media screen and (${device.sm}) {
    min-width: 125px;
  }
`;

const CtaImage = styled.img`
  height: 100%;
  object-fit: fill;
  max-height: 500px;
  z-index: 10;
  position: relative;

  @media screen and (${device.md}) {
    max-width: 250px;
  }
  @media screen and (${device.sm} ){
    max-width: 125px;
  }
`;

const Circle1 = styled(MotionCtaCircle)``;
const Circle2 = styled(MotionCtaCircle)``;
const Circle3 = styled(MotionCtaCircle)``;

export { CtaPhoto };
